// extracted by mini-css-extract-plugin
module.exports = {"toggle":"DebugThemeToggle_toggle__NXSp4","handle":"DebugThemeToggle_handle__TvV09","front":"DebugThemeToggle_front__athnI","back":"DebugThemeToggle_back__1qdmn"};